import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex-container background-white border-radius-20" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "new-nav-bar-container inline-flex background-white" }
const _hoisted_4 = { class: "tab-pane tab-flex-container" }
const _hoisted_5 = {
  key: 0,
  class: "new-toolbarContainer"
}
const _hoisted_6 = { class: "menu right-side-tool-bar font-weight-600 font-size-14 position-relative" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "inner-flex-container" }
const _hoisted_12 = { class: "margin-top-35 margin-bottom-30" }
const _hoisted_13 = { class: "font-weight-400 font-size-14" }
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "listings-container overflow-auto" }
const _hoisted_16 = {
  key: 0,
  class: "information-text-color text-center"
}
const _hoisted_17 = { class: "display-flex flex-direction-column" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Toaster = _resolveComponent("Toaster")!
  const _component_ModalPopup = _resolveComponent("ModalPopup")!
  const _component_EmailDomainManager = _resolveComponent("EmailDomainManager")!
  const _component_EmailBrandingDrawer = _resolveComponent("EmailBrandingDrawer")!
  const _component_VueTabs = _resolveComponent("VueTabs")!
  const _component_EmailBrandingListings = _resolveComponent("EmailBrandingListings")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_loading, {
      "show-loading": _ctx.showLoading,
      "border-color": _ctx.loaderBorderColor
    }, null, 8, ["show-loading", "border-color"]),
    (_ctx.showToaster)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Toaster, {
            message: _ctx.toasterMessage,
            type: _ctx.toasterType,
            "default-timeout": _ctx.toasterDefaultTimeout
          }, null, 8, ["message", "type", "default-timeout"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.modalPopupVisible)
      ? (_openBlock(), _createBlock(_component_ModalPopup, {
          key: 1,
          "show-modal-popup": _ctx.modalPopupVisible,
          "header-content": _ctx.modalPopupHeading,
          "body-heading": _ctx.modalPopupBodyHeading,
          "body-content": _ctx.modalPopupContent,
          "show-close-button": _ctx.showCloseButton,
          "show-cancel-button": _ctx.showCancelButton,
          "confirm-button-text": _ctx.buttonText,
          "cancel-button-text": _ctx.cancelButtonText,
          "image-url": _ctx.imageIcon,
          "show-confirm-button": _ctx.showConfirmButton,
          onConfirmClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ConfirmClick($event)))
        }, null, 8, ["show-modal-popup", "header-content", "body-heading", "body-content", "show-close-button", "show-cancel-button", "confirm-button-text", "cancel-button-text", "image-url", "show-confirm-button"]))
      : _createCommentVNode("", true),
    (_ctx.openDrawer)
      ? (_openBlock(), _createBlock(_component_EmailBrandingDrawer, {
          key: 2,
          "drawer-width": _ctx.defaultDrawerWidth
        }, {
          default: _withCtx(() => [
            _createVNode(_component_EmailDomainManager, {
              "domain-list": _ctx.domainRecords,
              "selected-type": _ctx.selectedDrawerType,
              "edit-email-address": _ctx.editEmailData,
              "selected-domian-id": _ctx.domainId,
              onDnsRecords: _cache[1] || (_cache[1] = ($event: any) => (_ctx.GetDomianRecords())),
              onVerifyDomainStatus: _ctx.VerifyDomainStatus,
              onReloadEmailListing: _ctx.GetListOfEmails,
              onOpenDeleteDomainModal: _ctx.ShowConfirmationModal
            }, null, 8, ["domain-list", "selected-type", "edit-email-address", "selected-domian-id", "onVerifyDomainStatus", "onReloadEmailListing", "onOpenDeleteDomainModal"])
          ]),
          _: 1
        }, 8, ["drawer-width"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_VueTabs, {
        "tab-view-model": _ctx.emailBrandingTabEntityList,
        onSelectedTab: _ctx.selectedTab
      }, null, 8, ["tab-view-model", "onSelectedTab"]),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "width30 no-mobile-item-display" }, [
        _createElementVNode("div", { class: "toggling-container margin-top-10" })
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (!_ctx.isMobileView)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _cache[7] || (_cache[7] = _createElementVNode("div", null, null, -1)),
            _createElementVNode("div", _hoisted_6, [
              (_ctx.showAddDomainButton)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    id: "btnCreateNewEvaluationQuestionItem",
                    class: "btn btn-size-header-large btn-secondary",
                    disabled: !_ctx.isPFActive,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.OpenDrawer(_ctx.DrawerType.DomainDrawer)))
                  }, [
                    _createElementVNode("img", { src: _ctx.domainGlobeIcon }, null, 8, _hoisted_8),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("OrgSettings.EmailBranding.ManageDomain")), 1)
                  ], 8, _hoisted_7))
                : _createCommentVNode("", true),
              (_ctx.isLoggedInUserSuperAdminOrAppAdmin)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    onMouseover: _cache[4] || (_cache[4] = ($event: any) => (_ctx.GetInformationString(true))),
                    onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.GetInformationString(false)))
                  }, [
                    _createElementVNode("button", {
                      id: "btnCreateNewEvaluationQuestionItem",
                      class: "btn btn-size-header-large btn-primary margin-left-20",
                      disabled: _ctx.isAddEmailButtonDisabled || !_ctx.isPFActive,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.OpenDrawer(_ctx.DrawerType.EmailDrawer)))
                    }, [
                      _createElementVNode("img", { src: _ctx.addActionIcon }, null, 8, _hoisted_10),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("OrgSettings.EmailBranding.AddEmailAddress")), 1)
                    ], 8, _hoisted_9)
                  ], 32))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", { class: "information-icon-div" }, _toDisplayString(_ctx.tooltipInfoMessage), 513), [
                [_vShow, _ctx.isDomainTooltipVisible]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("OrgSettings.EmailBranding.AddOrManageBrandDomainText")), 1),
          _createElementVNode("a", {
            href: _ctx.learnMoreLink,
            class: "font-weight-600 font-size-14 hyperLink",
            target: "_blank"
          }, _toDisplayString(_ctx.$t("EventSetting.Dialogues.LearnMore")), 9, _hoisted_14)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_EmailBrandingListings, {
            "email-domain-listings": _ctx.emailDomainListings,
            "premium-feature-enabled": _ctx.isPFActive,
            onEditEmailAddress: _ctx.EditEmailAddressInDrawer,
            onSetActiveEmail: _ctx.OpenActivateEmailConfirmationModal,
            onDeleteEmailAddress: _ctx.OpenDeleteEmailConfirmationModal,
            onOpenAlert: _ctx.ShowAlertDialog
          }, null, 8, ["email-domain-listings", "premium-feature-enabled", "onEditEmailAddress", "onSetActiveEmail", "onDeleteEmailAddress", "onOpenAlert"])
        ]),
        (!_ctx.isPFActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("span", {
                  class: "font-weight-400 font-size-14",
                  innerHTML: _ctx.$t('OrgSettings.EmailBranding.IsWhiteLabelledDomainsPFActiveText1')
                }, null, 8, _hoisted_18),
                _createElementVNode("span", {
                  innerHTML: _ctx.GetWhiteLabelText()
                }, null, 8, _hoisted_19)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.isMobileView)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "mobile-info-block",
            innerHTML: _ctx.$t('OrgSettings.EmailBranding.MobileViewInformationText')
          }, null, 8, _hoisted_20))
        : _createCommentVNode("", true)
    ])
  ]))
}